<div class="delete-floor-wrapper">
  <div>
    <mat-select
      hideSingleSelectionIndicator="true"
      [placeholder]="'commonLabels.select' | xTranslate"
      (selectionChange)="floorDeletionChange($event)"
    >
      <mat-option *ngFor="let del of deleteFloorsTypeList" [value]="del.value">
        {{ del.label | xTranslate }}
      </mat-option>
    </mat-select>
    <input
      type="text"
      readonly
      [value]="deleteFloorNumber ?? ''"
      [placeholder]="'exportToExcel.floorNumberHeader' | xTranslate"
    />
  </div>
  <div>
    <button mat-icon-button (click)="cancel()">
      <mat-icon svgIcon="clear"></mat-icon>
    </button>
    <button mat-icon-button (click)="saveDelete()" [disabled]="conflictsFound">
      <mat-icon svgIcon="done"></mat-icon>
    </button>
  </div>
</div>
